export const INTERVIEW_UPDATE_ETA_SOURCE = {
  JOB_DETAILS: "jobDetails",
  DEEP_LINK: "deepLink",
} as const;

export type InterviewUpdateEtaSource =
  (typeof INTERVIEW_UPDATE_ETA_SOURCE)[keyof typeof INTERVIEW_UPDATE_ETA_SOURCE];
